import React from 'react'
import { Field } from 'formik'

const Input = ({ name, placeholder, disabled = false, type, fieldClassName, as = '' }) => {
  return <Field id={name} name={name} placeholder={placeholder} disabled={disabled} type={type} className={fieldClassName} as={as} />
}

export default Input
